import { Outlet } from 'react-router';

import { AppHead } from './app-head.ui';

/**
 * T1 `App / Stack`(Figma 2142:13). 머리(배너 · 헤더 · BackBar) + 본문.
 * 본문: 폭 `size.container.page` 1380(DD-19) 가운데, 구획 사이 20(`space/5`), 위아래 32(`space/8`).
 * 좌우 여백 20(`spacing/gutter`, box-content — 1440 PC 는 그대로 1380, 그보다 좁으면 여백 20 을 남기고 줄어든다).
 * 구획을 어떻게 쌓을지(1열 · 1:1 두 열)는 화면(page)이 정한다(DD-15 H1). 태블릿(xl 1200 미만)은 두 열을 한 열로(DD-65).
 */
export function AppStackLayout() {
  return (
    <div data-template="app-stack" className="min-h-screen bg-bg-canvas text-fg-default">
      <AppHead />
      <main className="mx-auto box-content flex max-w-(--size-container-page) flex-col gap-5 px-gutter py-8">
        <Outlet />
      </main>
    </div>
  );
}
